export const DEBOUNCE_TIMEOUT_MILLISECONDS = 300;

export const truncateOptions = {
  length: 140,
  separator: ' ',
};
